var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStripesAngular = function SvgStripesAngular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 635,
    height: 541,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.249,
    y: 402.845,
    width: 28,
    height: 449,
    rx: 14,
    transform: "rotate(-150 24.249 402.845)",
    fill: "url(#stripes-angular_svg__a)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 147.11,
    y: 416.044,
    width: 28,
    height: 449,
    rx: 14,
    transform: "rotate(-150 147.11 416.044)",
    fill: "url(#stripes-angular_svg__b)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 392.832,
    y: 442.442,
    width: 28,
    height: 449,
    rx: 14,
    transform: "rotate(-150 392.832 442.442)",
    fill: "url(#stripes-angular_svg__c)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 269.971,
    y: 429.243,
    width: 28,
    height: 449,
    rx: 14,
    transform: "rotate(-150 269.971 429.243)",
    fill: "url(#stripes-angular_svg__d)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 515.692,
    y: 455.64,
    width: 28,
    height: 449,
    rx: 14,
    transform: "rotate(-150 515.692 455.64)",
    fill: "url(#stripes-angular_svg__e)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 232.998,
    y: 97.282,
    width: 29,
    height: 450,
    rx: 14.5,
    transform: "rotate(30 232.998 97.282)",
    fill: "url(#stripes-angular_svg__f)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 478.719,
    y: 123.679,
    width: 29,
    height: 450,
    rx: 14.5,
    transform: "rotate(30 478.719 123.679)",
    fill: "url(#stripes-angular_svg__g)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 355.858,
    y: 110.481,
    width: 28,
    height: 450,
    rx: 14,
    transform: "rotate(30 355.858 110.481)",
    fill: "url(#stripes-angular_svg__h)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 601.58,
    y: 136.878,
    width: 28,
    height: 450,
    rx: 14,
    transform: "rotate(30 601.58 136.878)",
    fill: "url(#stripes-angular_svg__i)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripes-angular_svg__a",
    x1: 38.249,
    y1: 402.845,
    x2: 38.249,
    y2: 851.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripes-angular_svg__b",
    x1: 161.11,
    y1: 416.044,
    x2: 161.11,
    y2: 865.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripes-angular_svg__c",
    x1: 406.832,
    y1: 442.442,
    x2: 406.832,
    y2: 891.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripes-angular_svg__d",
    x1: 283.971,
    y1: 429.243,
    x2: 283.971,
    y2: 878.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripes-angular_svg__e",
    x1: 529.692,
    y1: 455.64,
    x2: 529.692,
    y2: 904.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripes-angular_svg__f",
    x1: 247.498,
    y1: 97.282,
    x2: 247.498,
    y2: 547.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripes-angular_svg__g",
    x1: 493.219,
    y1: 123.679,
    x2: 493.219,
    y2: 573.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripes-angular_svg__h",
    x1: 369.858,
    y1: 110.481,
    x2: 369.858,
    y2: 560.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stripes-angular_svg__i",
    x1: 615.58,
    y1: 136.878,
    x2: 615.58,
    y2: 586.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgStripesAngular;